import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import index from '../views/index.vue'
import agenda from '../views/agenda.vue'
import signUp from '../views/signUp.vue'
import live from '../views/live.vue'
import personal from '../views/personal.vue'
import login from '../views/login.vue'
import register from '../views/register.vue'
import password from '../views/password.vue'

import pcagenda from '../views/pc/agenda.vue'
import pcsignUp from '../views/pc/signUp.vue'
import pclive from '../views/pc/live.vue'
import pcpersonal from '../views/pc/personal.vue'
import pclogin from '../views/pc/login.vue'
import pcindex from '../views/pc/index.vue'
import pcregister from '../views/pc/register.vue'
import pcpassword from '../views/pc/password.vue'

Vue.use(Router)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
},
{
    path: '/agenda',
    name: 'agenda',
    component: agenda
},
{
    path: '/pc/agenda',
    name: 'pcagenda',
    component: pcagenda
},
{
    path: '/index',
    name: 'index',
    component: index
},
{
    path: '/pc/index',
    name: 'pcindex',
    component: pcindex
},
{
    path: '/signUp',
    name: 'signUp',
    component: signUp
},
{
    path: '/pc/signUp',
    name: 'pcsignUp',
    component: pcsignUp
},
{
    path: '/personal',
    name: 'personal',
    component: personal
},
{
    path: '/pc/personal',
    name: 'pcpersonal',
    component: pcpersonal
},
{
    path: '/live',
    name: 'live',
    component: live,
    meta: {
        keepAlive: true,
        scollTopPosition: 0,
        showTab: true
    }
},
{
    path: '/pc/live',
    name: 'pclive',
    component: pclive,
    meta: {
        keepAlive: true,
        scollTopPosition: 0,
        showTab: true
    }
},
{
    path: '/login',
    name: 'login',
    component: login
},
{
    path: '/pc/login',
    name: 'pclogin',
    component: pclogin
},
{
    path: '/register',
    name: 'register',
    component: register
},
{
    path: '/pc/register',
    name: 'pcregister',
    component: pcregister
},
{
    path: '/password',
    name: 'password',
    component: password
},
{
    path: '/pc/password',
    name: 'pcpassword',
    component: pcpassword
},
]

const router = new Router({
    routes
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js